




































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IInvoice } from "@/models/invoices";
import HasValidation from "@/mixins/HasValidation";
import LoggedUserMixin from "@/mixins/loggedUserMixin";
import PaymentProvider from "@/components/app/global/payments/selectPaymentMethod/provider";
import { IPaymentDetail } from "@/models/paymentDetails";
import { QUERY_PARAMS } from "@/data/constants";

@Component({
  components: {
    "select-payment-method": () =>
      import("@/components/app/global/payments/selectPaymentMethod/index.vue")
  }
})
export default class InvoicePaymentModal extends Mixins(
  PaymentProvider,
  LoggedUserMixin,
  HasValidation
) {
  // Props
  @Prop({ required: true })
  public invoice!: IInvoice;

  @Prop({ default: "" })
  public preselectedStoredPaymentMethodId!: IPaymentDetail["id"];

  @Prop({ default: undefined })
  public preselectedShowPendingPayment!: boolean;

  // Data
  public isProcessing = false;
  public showPendingPayment = false;

  public created() {
    this.showPendingPayment = !this.$_.isNil(this.preselectedShowPendingPayment)
      ? this.preselectedShowPendingPayment
      : this.hasPendingPayment;
  }

  // Computed
  public get additionalManualPaymentData() {
    return {
      invoice_id: this.invoice.id
    };
  }

  public get oauthReturnRoute() {
    return this.$router.resolve({
      name: this.isAdmin ? "openAdminInvoice" : "openInvoice",
      params: {
        clientId: this.invoice.client_id,
        invoiceId: this.invoice.id as string
      }
    })?.route;
  }

  public get hasPendingPayment() {
    return !!this.invoice?.payments?.find(i => i.pending);
  }

  public get attemptKey() {
    return btoa(
      JSON.stringify({
        invoiceId: this.invoice.id,
        timestamp: this.$moment()
          .toDate()
          .getTime()
      })
    );
  }

  public get additionalPaymentData() {
    const returnUrl = this.generateReturnUrl();
    const returnUrlEncodedSuccess = encodeURIComponent(
      `${returnUrl}?${QUERY_PARAMS.PAYMENT_SUCCESS}=true&${QUERY_PARAMS.ATTEMPT}=${this.attemptKey}`
    );
    const returnUrlEncodedFail = encodeURIComponent(
      `${returnUrl}?${QUERY_PARAMS.PAYMENT_SUCCESS}=false&${QUERY_PARAMS.ATTEMPT}=${this.attemptKey}`
    );

    return {
      client_id: this.invoice.client_id,
      account_id: this.invoice.account_id,
      invoice_id: this.invoice.id,
      return_url: `?${QUERY_PARAMS.SUCCESS}=${returnUrlEncodedSuccess}&${QUERY_PARAMS.FAILED}=${returnUrlEncodedFail}`,
      cancel_url: returnUrl
    };
  }

  public get totalAmountToPay() {
    return this.invoice.unpaid_amount_converted;
  }

  // Methods
  public generateReturnUrl() {
    const location = this.$router.resolve({
      name: this.isAdmin
        ? "adminInvoice"
        : this.isMockClientContext
        ? "admin__upmindInvoice"
        : "clientInvoice",
      params: {
        clientId: this.invoice.client_id,
        invoiceId: this.invoice.id as string
      }
    });
    return `${window.location.origin}${location.href}`;
  }

  public async pay() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) throw this.$t("_.form_invalid");
      // Prepare payment data
      await this.preparePaymentData(this.invoice.client_id);
      // Execute payment
      await this.executePayment(this.attemptKey);
      // Exit if external flow (eg redirect to PayPal)
      if (this.hasExternalFlow) return;
      // Emit 'success'
      this.$emit("success");
    } catch (error) {
      this.isProcessing = false;
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
